// Version COUPLE de l'évaluation des besoins psychologiques.
// Items reformulés dans un cadre relationnel (FR / ES). Les noms, définitions et
// "ce que ce besoin n'est pas" sont réutilisés depuis data/needs.js (via la clé).

export const COUPLE_ITEMS = {
  securite: {
    fr: [
      "Dans ma relation, je peux anticiper ce qui va se passer au quotidien.",
      "Je me sens protégé(e) par mon/ma partenaire.",
      "Je n'ai pas peur qu'un problème survienne dans notre couple.",
      "Avec mon/ma partenaire, je peux me détendre sans être en état d'alerte.",
      "Je fais confiance à l'avenir de notre relation.",
    ],
    es: [
      "En mi relación, puedo anticipar lo que va a suceder en el día a día.",
      "Me siento protegido(a) por mi pareja.",
      "No tengo miedo de que surja un problema en nuestra pareja.",
      "Con mi pareja, puedo relajarme sin estar en estado de alerta.",
      "Confío en el futuro de nuestra relación.",
    ],
  },
  attachement: {
    fr: [
      "Je me sens aimé(e) dans ma relation de couple.",
      "Je peux compter sur mon/ma partenaire.",
      "Je me sens accepté(e) tel(le) que je suis par mon/ma partenaire.",
      "Je peux demander de l'aide à mon/ma partenaire sans culpabiliser.",
      "Je me sens émotionnellement proche de mon/ma partenaire.",
    ],
    es: [
      "Me siento amado(a) en mi relación de pareja.",
      "Puedo contar con mi pareja.",
      "Me siento aceptado(a) tal como soy por mi pareja.",
      "Puedo pedir ayuda a mi pareja sin sentirme culpable.",
      "Me siento emocionalmente cercano(a) a mi pareja.",
    ],
  },
  autonomie: {
    fr: [
      "Dans mon couple, je prends des décisions qui me ressemblent.",
      "Je peux dire non à mon/ma partenaire lorsque c'est nécessaire.",
      "Je me sens libre d'organiser mon quotidien au sein du couple.",
      "Je garde la maîtrise de ma vie tout en étant en couple.",
      "Je peux exprimer mes besoins librement à mon/ma partenaire.",
    ],
    es: [
      "En mi pareja, tomo decisiones que se parecen a mí.",
      "Puedo decir no a mi pareja cuando es necesario.",
      "Me siento libre de organizar mi día a día dentro de la pareja.",
      "Mantengo el control de mi vida aun estando en pareja.",
      "Puedo expresar mis necesidades libremente a mi pareja.",
    ],
  },
  competence: {
    fr: [
      "Je me sens capable de faire face aux difficultés de notre couple.",
      "J'ai confiance dans ma capacité à contribuer à la relation.",
      "Nous progressons sur ce qui est important pour notre couple.",
      "J'apprends de mes erreurs dans la relation.",
      "Je me sens utile et efficace dans notre vie commune.",
    ],
    es: [
      "Me siento capaz de afrontar las dificultades de nuestra pareja.",
      "Confío en mi capacidad para aportar a la relación.",
      "Progresamos en lo que es importante para nuestra pareja.",
      "Aprendo de mis errores en la relación.",
      "Me siento útil y eficaz en nuestra vida en común.",
    ],
  },
  reconnaissance: {
    fr: [
      "Mes efforts sont reconnus par mon/ma partenaire.",
      "Je me sens apprécié(e) par mon/ma partenaire.",
      "Mon/ma partenaire remarque mes qualités.",
      "Je me sens valorisé(e) dans notre relation.",
      "Je reçois suffisamment de retours positifs de mon/ma partenaire.",
    ],
    es: [
      "Mis esfuerzos son reconocidos por mi pareja.",
      "Me siento apreciado(a) por mi pareja.",
      "Mi pareja nota mis cualidades.",
      "Me siento valorado(a) en nuestra relación.",
      "Recibo suficientes comentarios positivos de mi pareja.",
    ],
  },
  identite: {
    fr: [
      "Je reste moi-même dans ma relation de couple.",
      "Mes valeurs restent claires au sein du couple.",
      "Je reste fidèle à moi-même avec mon/ma partenaire.",
      "Je n'ai pas besoin de jouer un rôle avec mon/ma partenaire.",
      "Je sais ce qui est important pour moi dans la relation.",
    ],
    es: [
      "Sigo siendo yo mismo(a) en mi relación de pareja.",
      "Mis valores siguen siendo claros dentro de la pareja.",
      "Me mantengo fiel a mí mismo(a) con mi pareja.",
      "No necesito interpretar un papel con mi pareja.",
      "Sé lo que es importante para mí en la relación.",
    ],
  },
  controle: {
    fr: [
      "J'ai le sentiment d'influencer ce qui dépend de moi dans le couple.",
      "Je peux agir lorsque quelque chose ne me convient pas dans la relation.",
      "Nous gérons efficacement les imprévus ensemble.",
      "Je sais réguler mes émotions lors de nos désaccords.",
      "Je distingue ce que je peux changer de ce que je ne peux pas changer dans le couple.",
    ],
    es: [
      "Tengo la sensación de influir en lo que depende de mí en la pareja.",
      "Puedo actuar cuando algo no me conviene en la relación.",
      "Gestionamos eficazmente los imprevistos juntos.",
      "Sé regular mis emociones en nuestros desacuerdos.",
      "Distingo lo que puedo cambiar de lo que no puedo cambiar en la pareja.",
    ],
  },
  plaisir: {
    fr: [
      "Je prends du plaisir régulièrement avec mon/ma partenaire.",
      "Nous profitons des moments agréables ensemble.",
      "Je ris facilement avec mon/ma partenaire.",
      "Je m'autorise à me détendre dans notre relation.",
      "Nous partageons des activités qui nous procurent de la joie.",
    ],
    es: [
      "Disfruto con regularidad con mi pareja.",
      "Aprovechamos juntos los momentos agradables.",
      "Me río con facilidad con mi pareja.",
      "Me permito relajarme en nuestra relación.",
      "Compartimos actividades que nos producen alegría.",
    ],
  },
  sens: {
    fr: [
      "Notre relation a du sens pour moi.",
      "Je comprends la direction que prend notre couple.",
      "Nos choix de couple correspondent à mes valeurs.",
      "Je me sens utile dans notre relation.",
      "Nous poursuivons des projets qui ont du sens pour moi.",
    ],
    es: [
      "Nuestra relación tiene sentido para mí.",
      "Comprendo la dirección que toma nuestra pareja.",
      "Nuestras decisiones de pareja corresponden a mis valores.",
      "Me siento útil en nuestra relación.",
      "Perseguimos proyectos que tienen sentido para mí.",
    ],
  },
  accomplissement: {
    fr: [
      "Je suis fier(e) de ce que nous construisons ensemble.",
      "Nous menons à bien nos projets communs.",
      "Je peux développer mon potentiel au sein du couple.",
      "Nous progressons vers nos objectifs communs.",
      "Je suis satisfait(e) de ce que j'apporte à la relation.",
    ],
    es: [
      "Estoy orgulloso(a) de lo que construimos juntos.",
      "Llevamos a buen término nuestros proyectos comunes.",
      "Puedo desarrollar mi potencial dentro de la pareja.",
      "Progresamos hacia nuestros objetivos comunes.",
      "Estoy satisfecho(a) con lo que aporto a la relación.",
    ],
  },
};

export const COUPLE_TIPS = {
  fr: {
    securite: "Qu'est-ce qui vous aiderait à vous sentir davantage en sécurité l'un avec l'autre ?",
    attachement: "Comment aimeriez-vous recevoir plus de marques d'affection ?",
    autonomie: "De quel espace personnel chacun a-t-il besoin dans le couple ?",
    competence: "Sur quoi aimeriez-vous vous sentir plus soutenu(e) par l'autre ?",
    reconnaissance: "Quels efforts de l'autre mériteraient d'être davantage reconnus ?",
    identite: "Comment préserver ce qui vous rend unique tout en étant ensemble ?",
    controle: "Comment mieux gérer ensemble les imprévus et les désaccords ?",
    plaisir: "Quelles activités partagées vous procureraient plus de plaisir ?",
    sens: "Quels projets communs donneraient plus de sens à votre relation ?",
    accomplissement: "Que souhaiteriez-vous construire ou accomplir ensemble ?",
  },
  es: {
    securite: "¿Qué os ayudaría a sentiros más seguros el uno con el otro?",
    attachement: "¿Cómo te gustaría recibir más muestras de afecto?",
    autonomie: "¿Qué espacio personal necesita cada uno en la pareja?",
    competence: "¿En qué te gustaría sentirte más apoyado(a) por el otro?",
    reconnaissance: "¿Qué esfuerzos del otro merecerían ser más reconocidos?",
    identite: "¿Cómo preservar lo que os hace únicos estando juntos?",
    controle: "¿Cómo gestionar mejor juntos los imprevistos y desacuerdos?",
    plaisir: "¿Qué actividades compartidas os darían más placer?",
    sens: "¿Qué proyectos comunes darían más sentido a vuestra relación?",
    accomplissement: "¿Qué querríais construir o lograr juntos?",
  },
};

export const COUPLE_T = {
  fr: {
    allModules: "← Tous les modules",
    title: "Besoins psychologiques — version couple",
    subtitle: "Explorez à deux la satisfaction de vos besoins et à quel point vous vous connaissez.",
    modeTitle: "Comment souhaitez-vous répondre ?",
    modeSame: "Sur le même appareil",
    modeSameDesc: "À tour de rôle, l'un après l'autre sur cet écran.",
    modeTwo: "Sur deux appareils",
    modeTwoDesc: "Chacun sur son téléphone, reliés par un code de séance.",
    start: "Commencer",
    prev: "Précédent",
    next: "Suivant",
    createTitle: "Créer une séance",
    createBtn: "Créer une séance",
    joinTitle: "Rejoindre une séance",
    joinPlaceholder: "Code de séance",
    joinBtn: "Rejoindre",
    or: "ou",
    codeLabel: "Votre code de séance",
    shareCode: "Communiquez ce code à votre partenaire, ou faites-lui scanner ce QR code.",
    continue: "Continuer",
    waiting: "En attente de votre partenaire…",
    waitingDesc: "Vos résultats communs s'afficheront dès que vous aurez tous les deux terminé.",
    refresh: "Actualiser",
    invalidCode: "Code introuvable. Vérifiez et réessayez.",
    nameLabel: "Votre prénom (facultatif)",
    namePlaceholder: "Prénom",
    partner1: "Partenaire 1",
    partner2: "Partenaire 2",
    intro1: "Vous allez répondre à 50 affirmations sur la satisfaction de vos besoins dans le couple (échelle 0 à 4).",
    intro2: "Ensuite, vous estimerez votre propre satisfaction, puis celle de votre partenaire, de 0 à 20.",
    intro3: "Aucun résultat ne s'affiche pendant la passation. Répondez spontanément et sincèrement.",
    begin: "Commencer",
    handoffTitle: "Passez l'appareil",
    handoffDesc: "Merci ! Passez maintenant l'appareil à votre partenaire, puis appuyez pour continuer.",
    handoffBtn: "Continuer",
    needLabel: "Besoin",
    needOf: "sur",
    completeItems: "Merci de répondre à tous les items pour continuer.",
    selfTitle: "Votre propre satisfaction",
    selfSub: "Estimez globalement, de 0 à 20, à quel point chacun de ces besoins est satisfait pour VOUS dans le couple.",
    otherTitle: "Et selon vous, pour votre partenaire ?",
    otherSub: "Estimez, de 0 à 20, à quel point vous pensez que chacun de ces besoins est satisfait pour VOTRE PARTENAIRE.",
    notLabel: "Ce besoin n'est pas",
    lowSat: "Peu satisfait (0)",
    highSat: "Pleinement satisfait (20)",
    seeResults: "Voir nos résultats",
    completeSliders: "Merci de positionner le curseur pour chaque besoin afin de continuer.",
    submitting: "Enregistrement…",
    // Résultats
    thanks: "Merci d'avoir complété cet exercice à deux",
    thanksText: "Ces résultats sont un support de dialogue, non un jugement. Ils comparent la satisfaction de vos besoins et la justesse avec laquelle vous percevez ceux de l'autre.",
    radarTitle: "Vos deux profils de satisfaction",
    radarSub: "Satisfaction mesurée (0–20)",
    tableTitle: "Besoin par besoin",
    colNeed: "Besoin",
    colGap: "Écart",
    colStatus: "Statut",
    statusAligned: "Aligné",
    statusModerate: "Nuancé",
    statusDivergent: "Divergent",
    knowTitle: "À quel point vous connaissez-vous ?",
    knowSub: "Précision de votre estimation des besoins de l'autre (plus c'est élevé, mieux vous le/la percevez).",
    accuracy: "Précision",
    knows: "perçoit",
    perceptionTitle: "Écart perçu / réel, besoin par besoin",
    perceptionSub: "Ce que chacun imagine de l'autre, comparé à sa réalité (0 = perception juste ; + = surestime ; − = sous-estime).",
    alignedTitle: "Vos points d'accord",
    alignedNote: "Besoins vécus de façon proche par vous deux.",
    divergentTitle: "Vos points de divergence",
    divergentNote: "Besoins où vos ressentis diffèrent le plus.",
    dialogueTitle: "Pistes de dialogue",
    synthTitle: "Synthèse",
    exportPdf: "Exporter en PDF",
    restart: "Nouvelle passation",
    none: "—",
  },
  es: {
    allModules: "← Todos los módulos",
    title: "Necesidades psicológicas — versión pareja",
    subtitle: "Explorad juntos la satisfacción de vuestras necesidades y hasta qué punto os conocéis.",
    modeTitle: "¿Cómo queréis responder?",
    modeSame: "En el mismo dispositivo",
    modeSameDesc: "Por turnos, uno tras otro en esta pantalla.",
    modeTwo: "En dos dispositivos",
    modeTwoDesc: "Cada uno en su móvil, conectados por un código de sesión.",
    start: "Empezar",
    prev: "Anterior",
    next: "Siguiente",
    createTitle: "Crear una sesión",
    createBtn: "Crear una sesión",
    joinTitle: "Unirse a una sesión",
    joinPlaceholder: "Código de sesión",
    joinBtn: "Unirse",
    or: "o",
    codeLabel: "Tu código de sesión",
    shareCode: "Comparte este código con tu pareja, o pídele que escanee este código QR.",
    continue: "Continuar",
    waiting: "Esperando a tu pareja…",
    waitingDesc: "Vuestros resultados comunes se mostrarán en cuanto ambos hayáis terminado.",
    refresh: "Actualizar",
    invalidCode: "Código no encontrado. Verifica e inténtalo de nuevo.",
    nameLabel: "Tu nombre (opcional)",
    namePlaceholder: "Nombre",
    partner1: "Pareja 1",
    partner2: "Pareja 2",
    intro1: "Vas a responder a 50 afirmaciones sobre la satisfacción de tus necesidades en la pareja (escala 0 a 4).",
    intro2: "Después, estimarás tu propia satisfacción y luego la de tu pareja, de 0 a 20.",
    intro3: "No se muestra ningún resultado durante la pasación. Responde con espontaneidad y sinceridad.",
    begin: "Comenzar",
    handoffTitle: "Pasa el dispositivo",
    handoffDesc: "¡Gracias! Pasa ahora el dispositivo a tu pareja y pulsa para continuar.",
    handoffBtn: "Continuar",
    needLabel: "Necesidad",
    needOf: "de",
    completeItems: "Responde a todos los ítems para continuar.",
    selfTitle: "Tu propia satisfacción",
    selfSub: "Estima globalmente, de 0 a 20, en qué medida está satisfecha cada necesidad para TI en la pareja.",
    otherTitle: "¿Y según tú, para tu pareja?",
    otherSub: "Estima, de 0 a 20, en qué medida crees que cada necesidad está satisfecha para TU PAREJA.",
    notLabel: "Esta necesidad no es",
    lowSat: "Poco satisfecha (0)",
    highSat: "Plenamente satisfecha (20)",
    seeResults: "Ver nuestros resultados",
    completeSliders: "Coloca el cursor para cada necesidad para continuar.",
    submitting: "Guardando…",
    thanks: "Gracias por completar este ejercicio en pareja",
    thanksText: "Estos resultados son un apoyo para el diálogo, no un juicio. Comparan la satisfacción de vuestras necesidades y la exactitud con la que percibís las del otro.",
    radarTitle: "Vuestros dos perfiles de satisfacción",
    radarSub: "Satisfacción medida (0–20)",
    tableTitle: "Necesidad por necesidad",
    colNeed: "Necesidad",
    colGap: "Diferencia",
    colStatus: "Estado",
    statusAligned: "Alineado",
    statusModerate: "Matizado",
    statusDivergent: "Divergente",
    knowTitle: "¿Hasta qué punto os conocéis?",
    knowSub: "Exactitud de tu estimación de las necesidades del otro (cuanto más alta, mejor lo/la percibes).",
    accuracy: "Exactitud",
    knows: "percibe a",
    perceptionTitle: "Diferencia percibida / real, necesidad por necesidad",
    perceptionSub: "Lo que cada uno imagina del otro, comparado con su realidad (0 = percepción ajustada ; + = sobrestima ; − = subestima).",
    alignedTitle: "Vuestros puntos de acuerdo",
    alignedNote: "Necesidades vividas de forma parecida por ambos.",
    divergentTitle: "Vuestros puntos de divergencia",
    divergentNote: "Necesidades donde vuestras vivencias difieren más.",
    dialogueTitle: "Pistas de diálogo",
    synthTitle: "Síntesis",
    exportPdf: "Exportar en PDF",
    restart: "Nueva pasación",
    none: "—",
  },
};
